/**
 * Created by Ivan on 05.07.2026
 */

class KingsCupVerticalTableRowView {
    constructor(row, options) {
        // eslint-disable-next-line no-constructor-return
        return Prefab.instantiate(bundles.kingscup_window.jsons.kingscup_vertical_tablerow_prefab_json, { args: [row, options] });
    }
}

KingsCupLogic.ROW_VIEWS["KingsCupVerticalTableRowView"] = KingsCupVerticalTableRowView;
